export default __webpack_public_path__ + "static/media/wsb-large-logo.5d65a55c.png";